export const getScannerLink = (address: string, network: string) => {
  switch (network) {
    case '137':
      return `https://polygonscan.com/address/${address}`;
    case '42161':
      return `https://arbiscan.io/address/${address}`;
    case '1':
      return `https://etherscan.io/address/${address}`;
    case '8453':
      return `https://basescan.org/address/${address}`;
    default:
      return '';
  }
};
